import PropTypes from "prop-types";
import { useEffect } from "react";

// Layouts
import SingleTiersLoader from "@/Layouts/components/Skeletons/SingleTiersLoader";

// Custom components
import MetricProducts from "@/PayPlans/components/Commons/MetricProducts";

// MUI
import { Grid } from "@mui/material";

export default function ProductBonuses(props) {
	const {
		sectionId = "productBonuses",
		products = [],
		backProducts = [],
		loading = false,
		loadingProducts = false,
		readOnly = false,
		useSectionsErrors = () => {},
		onActionUpdate = () => {},
	} = props;
	const { addSectionError, removeSectionError, clearSectionErrors } = useSectionsErrors?.() || {};

	const handleUpdate = (updatedProducts) => {
		onActionUpdate?.(sectionId, null, updatedProducts);
	};

	const handleValidation = (isValid) => {
		isValid ? removeSectionError?.(sectionId) : addSectionError?.(sectionId);
	};

	useEffect(() => {
		return () => {
			clearSectionErrors?.(sectionId);
		};
	}, [sectionId, clearSectionErrors]);

	return (
		<Grid container>
			{loading ? (
				<SingleTiersLoader selector buttons />
			) : (
				<Grid item xs={12} mt={3} sx={{ padding: "0 32px" }}>
					<MetricProducts
						products={products || []}
						listProducts={backProducts}
						useDefaultRate
						boostPVR
						useGrossModifier
						loadingProducts={loadingProducts}
						readOnly={readOnly}
						onActionUpdate={handleUpdate}
						onActionValidation={handleValidation}
					/>
				</Grid>
			)}
		</Grid>
	);
}
ProductBonuses.propTypes = {
	sectionId: PropTypes.string,
	products: PropTypes.array,
	backProducts: PropTypes.array,
	loading: PropTypes.bool,
	loadingProducts: PropTypes.bool,
	readOnly: PropTypes.bool,
	useSectionsErrors: PropTypes.func,
	onActionUpdate: PropTypes.func,
};
